import { Checkbox, Select } from 'antd';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import Input from '../../../../components/input/Input';
import {
    Bank,
    ConfigData,
    InvestmentProduct
} from '../../../../customhooks/investments/useInvestmentOptions';
import Button from '../../../../components/button/Button';

const BankingDetails = ({
    investmentOptions,
    products,
    isLoading
}: {
    investmentOptions: ConfigData;
    products: InvestmentProduct[];
    isLoading: boolean;
}) => {
    const {
        values,
        errors,
        setFieldValue,
        touched,
        isValid
    } = useFormikContext<any>();

    return (
        <div className='space-y-4 max-w-lg'>
            <h2 className='text-lg font-medium'>
                Provide banking & investment information
            </h2>

            <div className='mb-6 space-y-4'>
                <div>
                    <label
                        htmlFor='bank'
                        className='block mb-2 text-sm font-medium text-gray700 text-left'
                    >
                        Bank name
                    </label>
                    <Select
                        style={{ borderRadius: '8px' }}
                        className='w-full h-[45px] rounded-[8px]'
                        id='bankName'
                        showSearch
                        onChange={(value) => {
                            const selectedBank = investmentOptions?.banks?.find(
                                (bank) => bank.bankCode === value
                            );
                            setFieldValue('bankName', selectedBank?.bankName);
                            setFieldValue('bankCode', value);
                        }}
                        value={values?.bankCode}
                        options={investmentOptions?.banks?.map(
                            (bank: Bank) => ({
                                label: (
                                    <div className='flex gap-2 items-center'>
                                        {bank.bankName} ({bank.bankCode} -{' '}
                                        {bank.branchCode})
                                    </div>
                                ),
                                value: bank.bankCode,
                                labelText: bank.bankName
                            })
                        )}
                        filterOption={(input, option) => {
                            if (!option) return false;
                            return option.labelText
                                ?.toLowerCase()
                                .includes(input.toLowerCase());
                        }}
                    />
                    {errors.bankName && (
                        <p className='text-xs text-red100'>
                            {errors.bankName as string}
                        </p>
                    )}
                </div>

                <Field
                    as={Input}
                    isError={touched?.accountNumber && errors?.accountNumber}
                    errorMessage={
                        touched?.accountNumber && errors?.accountNumber
                    }
                    required
                    type='number'
                    maxLength={10}
                    label='Account number'
                    name='accountNumber'
                    value={values?.accountNumber}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                        setFieldValue('accountNumber', e.target.value);
                    }}
                />

                <div>
                    <label
                        htmlFor='input-group-1'
                        className='block mb-2 text-sm font-medium text-gray700 text-left'
                    >
                        Select an investment product
                    </label>
                    <Select
                        style={{ borderRadius: '8px' }}
                        className='w-full h-[45px] rounded-[8px]'
                        id='categoryOfBusiness'
                        disabled
                        options={products?.map((item: InvestmentProduct) => ({
                            label: (
                                <div className='flex gap-2 items-center'>
                                    {item.name} ({item.code})
                                </div>
                            ),
                            value: item.code,
                            labelText: item.name
                        }))}
                        value={values.productCode}
                    />
                </div>

                <div className='w-full'>
                    <Checkbox
                        checked={values.rollover}
                        onChange={(e) =>
                            setFieldValue('rollover', !values.rollover)
                        }
                        className='custom-checkbox text-gray700 font-semibold'
                    >
                        Reinvest my dividends
                    </Checkbox>
                </div>

                <div className='pt-4 w-full'>
                    <Button
                        text='Save and Continue'
                        className='w-full'
                        type='submit'
                        disabled={!isValid}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </div>
    );
};

export default BankingDetails;
